import { useEffect } from "react";
import { useState } from "react";
import { useAuth } from "./auth";
import { useUserStore } from "./userStore";
import EventsService from "../services/EventsService";
import { useContext } from "react";
import { subscribe, unsubscribe } from "../utils/events";

const { createContext } = require("react");

const AlarmsContext = createContext({
	alarms: []
})

export const AlarmsProvider = ({ children }) => {
	const [alarms, setAlarms] = useState([]);
	const { user } = useAuth();
	const { selectedCondominioObj } = useUserStore();

	async function loadAlarms() {
		if (!selectedCondominioObj) return;
		const response = await EventsService.listViolationsAndPanics(selectedCondominioObj.id);
		if (response.data) {
			setAlarms(response.data)
		}
	}

	function onSseReceived(ssePayload) {
		if (ssePayload.action === 'createEvent' && (ssePayload.content.name.includes('panico') || ssePayload.content.name.includes('violada') || ssePayload.content.data.includes('panico'))) {
			setAlarms(alarms => {
				const newAlarms = [...alarms, ssePayload.content];
				return newAlarms.sort((a, b) => b.id - a.id);
			})
		}
		if (ssePayload.action === 'deviceEventConfirmation') {
			setAlarms(alarms => alarms.filter(alarm => alarm.id !== ssePayload.content.deviceEventId));
		}
		if (ssePayload.action === 'deviceBatchEventsConfirmation') {
			loadAlarms();
		}
	}

	useEffect(() => {
		subscribe('onSseReceived', onSseReceived);
		return () => {
			unsubscribe('onSseReceived', onSseReceived);
		}
	}, [user])

	useEffect(() => {
		if (!selectedCondominioObj) return;
		loadAlarms();
	}, [selectedCondominioObj]);

	return (
		<AlarmsContext.Provider value={{ alarms }}>
			{children}
		</AlarmsContext.Provider>
	);
}

export function useAlarms() {
	const context = useContext(AlarmsContext);
	return context;
}